import { useMemo } from 'react';

import { Box } from '@betterment/samba-react';

import { SUPPORT_EMAIL } from '../Shared/constants';

const buildAcatsError = (email: string) => {
  return (
    <Box css={{ color: 'text.weak' }}>
      If you have any questions, please reach out to {email} with the client information and statement.
    </Box>
  );
};

export const useAdvisorsContactMail = () => {
  const contactTexts = useMemo(
    () => ({
      acatsError: buildAcatsError(SUPPORT_EMAIL),
    }),
    []
  );

  return contactTexts;
};
